<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />

			<!-- 第一层（替换为“携手合作”板块） -->
			<div class="row"
				style="position: relative; text-align: left; padding: 80px 0; background: linear-gradient(338deg, #eeeeff, transparent) ; overflow: hidden;">
				<div
					style="width: 1200px; margin: 0 auto; display: flex; justify-content: space-between; align-items: center; position: relative; gap: 80px;">
					<!-- 左侧：文字+指定图片（替换原装饰图形） -->
					<div style="width: 50%; z-index: 1;">
						<div
							style="font-size: 36px; font-weight: bold; color: #333; line-height: 1.4; margin-bottom: 20px;margin-top: 60px;">
							携手合作，共创智能<br>新篇章
						</div>
						<div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 30px;">
							我们期待与有远见的企业共同探索数字化转型的无限可能。让我们从这次接触开始，携手构建更安全、高效、协同的未来。
						</div>
						<!-- 圈红区域的图片 -->
						<div style="text-align: left;">
							<img src="../../assets/img/schz1.png" style="height: 340px;" />
						</div>
					</div>


					<div
						style="width: 50%; background: #ffffffa8; border-radius: 12px; padding: 60px 40px; box-shadow: 0 4px 16px rgba(0,0,0,0.05); z-index: 1; margin-top: 80px;">
						<form @submit.prevent="toContact">
							<div style="font-size: 22px;margin-bottom: 40px;">联系我们</div>
							<div style="margin-bottom: 20px;">
								<label
									style="font-size: 14px; color: #666; margin-bottom: 6px; display: block;margin-bottom: 10px;">企业名称</label>
								<input v-model="contactForm.companyName" type="text" placeholder="请输入企业名称"
									style="width: 100%; padding: 12px 14px;height: 32px; border: 1px solid #eee; border-radius: 4px; outline: none; font-size: 12px; color: #333;">
							</div>


							<div style="margin-bottom: 20px;">
								<label
									style="font-size: 14px; color: #666; margin-bottom: 6px; display: block;margin-bottom: 10px;">你的职位</label>
								<input v-model="contactForm.position" type="text" placeholder="请输入职位"
									style="width: 100%; padding: 12px 14px; height: 32px; border: 1px solid #eee; border-radius: 4px; outline: none; font-size: 12px; color: #333;">
							</div>


							<div style="margin-bottom: 20px;">
								<label
									style="font-size: 14px; color: #666; margin-bottom: 6px; display: block;margin-bottom: 10px;">联系电话</label>
								<input v-model="contactForm.phone" type="tel" placeholder="请输入电话"
									style="width: 100%; padding: 12px 14px; height: 32px; border: 1px solid #eee; border-radius: 4px; outline: none; font-size: 12px; color: #333;">
							</div>

							<div style="margin-bottom: 25px;">
								<label
									style="font-size: 14px; color: #666; margin-bottom: 6px; display: block;">公司行业</label>
								<textarea v-model="contactForm.industry" placeholder="请描述您的需求，以使于我们更好的了解您的诉求"
									style="width: 100%; padding: 12px 14px; border: 1px solid #eee; border-radius: 4px; outline: none; resize: none; height: 80px; font-size: 12px; color: #333; line-height: 1.5;"></textarea>
							</div>


							<div style="text-align: center;">
								<button type="submit" :disabled="submitting"
									style="width: 20%; padding: 16px; background: #333; color: #fff; border: none; border-radius: 8px; cursor: pointer; font-size: 14px; font-weight: 600; transition: all 0.3s ease; box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);margin-top: 40px;"
									onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 16px rgba(64, 158, 255, 0.4)'"
									onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 12px rgba(64, 158, 255, 0.3)'"
									onmousedown="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 8px rgba(64, 158, 255, 0.3)'">
									{{ submitting ? '提交中...' : '提交' }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>

		</div>


		<div class="contner">
			<div class="prduct-box">
				<div style="font-size: 42px;padding: 100px 0 60px; text-align: center;">联系我们</div>
				<div style="width: 30%;padding: 36px 0px;float: left;">
					<div class="item-no" style="color: #666;font-size: 26px;font-weight: bold;">
						联 系 信 息
					</div>
					<div class="item-no" style="color: #7d7d7d;font-size: 18px;margin-top: 60px;">
						地址: 上海市青浦区崧达路800号
					</div>
					<div class="item-no" style="color: #7d7d7d;font-size: 16px;margin-top: 30px;">
						电话: 021-59883199
					</div>

					<div class="item-no" style="color: #7d7d7d;font-size: 16px;margin-top: 30px;">
						邮箱: luohq@zenner-metering.com
					</div>
				</div>

				<div style="width: 70%;padding: 36px 0px;float: left;">
					<baidu-map style="position: relative;" class="bmView" ak="8oGIXq7E7OFkDOVzEbiwu5giDGYMCewQ"
						:zoom="zoom" :center="{ lng: location.lng, lat: location.lat }" :scroll-wheel-zoom="true">

						<bm-marker-clusterer :averageCenter="true">
							<bm-marker v-for="marker of markers"
								:position="{ lng: marker.lng, lat: marker.lat }"></bm-marker>
						</bm-marker-clusterer>
					</baidu-map>
				</div>

			</div>
		</div>
		<Foot />
	</div>
</template>

<script>
import Nav from "./nav.vue";
import Foot from "./foot.vue";
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarkerClusterer from 'vue-baidu-map/components/extra/MarkerClusterer'
import { WEB3FORMS_ACCESS_KEY, CONTACT_FORM_SUBJECT } from "@/config/emailService";
export default {
	name: "App",
	components: {
		Nav,
		Foot,
		BaiduMap,
		BmMarkerClusterer,
	},
	data() {
		return {
			curHeight: 0,
			location: {
				lng: 121.183205,
				lat: 31.169685
			},
			markers: [{
				lng: 121.183205,
				lat: 31.169685
			}],
			zoom: 12,
			addressKeyword: "",
			submitting: false,
			contactForm: {
				companyName: "",
				position: "",
				phone: "",
				industry: "",
			},
		};
	},
	watch: {
		windowHeight(val) {
			let that = this;
			console.log("实时屏幕高度：", val, that.windowHeight);
		},
	},
	beforeMount() {

		var h = document.documentElement.clientHeight || document.body.clientHeight;

		this.curHeight = h; //减去页面上固定高度height

	},
	methods: {
		toContact() {
			const { companyName, position, phone, industry } = this.contactForm;

			if (!companyName.trim()) {
				this.$Message.warning("请输入企业名称");
				return;
			}
			if (!phone.trim()) {
				this.$Message.warning("请输入联系电话");
				return;
			}

			this.submitting = true;

			if (!WEB3FORMS_ACCESS_KEY) {
				this.$Message.warning("邮件服务未配置，请联系网站管理员");
				this.submitting = false;
				return;
			}

			const message = [
				`企业名称：${companyName.trim()}`,
				`职位：${position.trim() || "未填写"}`,
				`联系电话：${phone.trim()}`,
				`公司行业及需求：${industry.trim() || "未填写"}`,
			].join("\n");

			fetch("https://api.web3forms.com/submit", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify({
					access_key: WEB3FORMS_ACCESS_KEY,
					subject: CONTACT_FORM_SUBJECT,
					from_name: "贸宝官网联系表单",
					name: companyName.trim(),
					phone: phone.trim(),
					message,
				}),
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.success) {
						this.$Message.success("提交成功，我们会尽快与您联系");
						this.contactForm = {
							companyName: "",
							position: "",
							phone: "",
							industry: "",
						};
					} else {
						this.$Message.warning(data.message || "提交失败，请稍后重试");
					}
				})
				.catch(() => {
					this.$Message.warning("提交失败，请稍后重试");
				})
				.finally(() => {
					this.submitting = false;
				});
		},
	},

	mounted() {
		var that = this;

		window.onresize = () => {
			return (() => {
				window.fullHeight = document.documentElement.clientHeight;
				that.curHeight = window.fullHeight; // 高

			})()
		};
	},
};
</script>
<style scoped>
.main-content {
	min-height: 100%;
	min-width: 1400px;
	width: 100%;
	margin: 0 auto;
	display: block;
	position: absolute;
	/* background: #f7f7f7; */
}

.prduct-box {
	width: 1200px;
	/* padding-top: 60px; */
	padding-bottom: 100px;
	margin: 0 auto;
	position: relative;
	height: 760px;

}

.contner {
	background: linear-gradient(86deg, #c1e4fd75, transparent);
}

.center-body {
	margin: 0 auto;
}

.fixed-bottom {
	position: fixed;
	bottom: 0;
}

.bmView {
	height: 400px;
}
</style>
<style>
.BMap_noprint {
	display: none !important;
}

.anchorBL {
	display: none;
}
</style>